var exports = {
  "kL": "InlineAudioPlayer.module__container___VnlGQS",
  "wx": "InlineAudioPlayer.module__header___VnlGQS",
  "Rr": "InlineAudioPlayer.module__playButton___VnlGQS",
  "CJ": "InlineAudioPlayer.module__playButtonIcon___VnlGQS",
  "sp": "InlineAudioPlayer.module__loadingSpinnerDesktop___VnlGQS",
  "t0": "InlineAudioPlayer.module__spin___VnlGQS",
  "XE": "InlineAudioPlayer.module__fileInfo___VnlGQS",
  "Md": "InlineAudioPlayer.module__fileName___VnlGQS",
  "m$": "InlineAudioPlayer.module__fileNameTruncate___VnlGQS",
  "i_": "InlineAudioPlayer.module__fileExtension___VnlGQS",
  "gM": "InlineAudioPlayer.module__fileMeta___VnlGQS",
  "NE": "InlineAudioPlayer.module__progressSection___VnlGQS",
  "hr": "InlineAudioPlayer.module__progressBar___VnlGQS",
  "Td": "InlineAudioPlayer.module__time___VnlGQS",
  "ne": "InlineAudioPlayer.module__controls___VnlGQS",
  "it": "InlineAudioPlayer.module__controlsLeft___VnlGQS",
  "BT": "InlineAudioPlayer.module__controlsRight___VnlGQS",
  "Wq": "InlineAudioPlayer.module__volumeControl___VnlGQS",
  "hP": "InlineAudioPlayer.module__actionButton___VnlGQS",
  "AA": "InlineAudioPlayer.module__mobileContainer___VnlGQS",
  "xk": "InlineAudioPlayer.module__mobilePlayButton___VnlGQS",
  "S": "InlineAudioPlayer.module__loadingSpinner___VnlGQS",
  "_S": "InlineAudioPlayer.module__mobileContainerActive___VnlGQS",
  "wh": "InlineAudioPlayer.module__mobileContent___VnlGQS",
  "Vg": "InlineAudioPlayer.module__mobileFileInfo___VnlGQS",
  "Yg": "InlineAudioPlayer.module__mobileFileName___VnlGQS",
  "kB": "InlineAudioPlayer.module__mobileFileMeta___VnlGQS",
  "hb": "InlineAudioPlayer.module__mobileProgressContainer___VnlGQS",
  "jw": "InlineAudioPlayer.module__mobileProgressTrack___VnlGQS",
  "lm": "InlineAudioPlayer.module__mobileProgressTrackActive___VnlGQS",
  "$r": "InlineAudioPlayer.module__mobileProgressFill___VnlGQS",
  "LI": "InlineAudioPlayer.module__mobileProgressFillActive___VnlGQS",
  "zr": "InlineAudioPlayer.module__mobileTimestamp___VnlGQS",
};

module.exports = exports;
